<div class="alert-cell-wrap">
  <span
    class="component-icon status-icon {{ severity }}"
    [inlineSVG]="componentTypeIcon"></span>
  <span class="alert-message">{{ alertMessage }}</span>
</div>
